import { all, call, takeEvery, put } from 'redux-saga/effects';
import { notifySuccess, notifyError } from 'utils/notifications';
import {
  SET_SEARCH_PENDING,
  SET_SUB_TABLE_QUERY_PENDING,
  SET_ACTIVE_LISTINGS,
  GET_ACTIVE_LISTINGS,
  SET_PRODUCT_VARIANTS,
  GET_PRODUCT_VARIANTS,
  SET_PRODUCT_VARIANTS_ERROR,
  SET_NEED_TO_CONFIRM_ORDERS,
  GET_NEED_TO_CONFIRM_ORDERS,
  CONFIRM_ORDER,
  CONFIRM_ORDER_SUCCESS,
  CONFIRM_ORDER_FAIL,
  CANCEL_ORDER,
  CANCEL_ORDER_SUCCESS,
  GET_NEED_TO_SHIP_ORDERS,
  SET_NEED_TO_SHIP_ORDERS,
  GET_OPEN_ORDERS,
  SET_OPEN_ORDERS,
  GET_SHIPPED_ORDERS,
  SET_SHIPPED_ORDERS,
  GET_DELIVERED_ORDERS,
  SET_DELIVERED_ORDERS,
  GET_RETURNED_ORDERS,
  SET_RETURNED_ORDERS,
  GET_CANCELED_ORDERS,
  SET_CANCELED_ORDERS,
  GET_COMPLETED_ORDERS,
  SET_COMPLETED_ORDERS,
  UPDATE_PRODUCT_PRICE,
  RESET_STORE_PRICE,
  SET_ACTIVE_LISTINGS_ERROR,
  LABEL_PRINTED,
  STATUS_UPDATED_SUCCESS,
  STATUS_UPDATED_FAIL,
} from 'store/constants/action-types';
import {
  getListOfPTs,
  getProductVariants,
  getNeedToConfirmOrders,
  getNeedToShipOrders,
  cancelOrder,
  confirmOrder,
  getAllOpenOrders,
  getShippedOrders,
  getDeliveredOrders,
  getReturnedOrders,
  getCanceledOrders,
  getAllCompletedOrders,
  updateProductPrice,
  resetToStorePrice,
  labelPrintedIndicator,
} from 'services/api/data-api';

export function* getListings(action) {
  try {
    yield put({ type: SET_SEARCH_PENDING, payload: true });
    const response = yield call(getListOfPTs, action.page ? action.page : 1);
    yield put({ type: SET_ACTIVE_LISTINGS, payload: response });
    yield put({ type: SET_SEARCH_PENDING, payload: false });
  } catch (error) {
    console.log(error);
  }
}

export function* getVariants(action) {
  try {
    yield put({ type: SET_SUB_TABLE_QUERY_PENDING, payload: { pending: true, id: action.id } });
    const response = yield call(getProductVariants, action.id);
    yield put({
      type: SET_PRODUCT_VARIANTS,
      payload: { id: action.id, variants: response.productVariants },
    });
    yield put({ type: SET_SUB_TABLE_QUERY_PENDING, payload: { pending: false, id: action.id } });
  } catch (error) {
    yield put({ type: SET_PRODUCT_VARIANTS_ERROR });
  }
}

export function* getNeedToConfirmOrder(action) {
  try {
    yield put({ type: SET_SEARCH_PENDING, payload: true });
    const response = yield call(getNeedToConfirmOrders, action.page ? action.page : 1);
    yield put({
      type: SET_NEED_TO_CONFIRM_ORDERS,
      orderType: action.orderType,
      payload: response,
    });
    yield put({ type: SET_SEARCH_PENDING, payload: false });
  } catch (error) {
    console.log(error);
  }
}

export function* getNeedToShipOrder(action) {
  try {
    yield put({ type: SET_SEARCH_PENDING, payload: true });
    const response = yield call(getNeedToShipOrders, action.page ? action.page : 1);
    yield put({
      type: SET_NEED_TO_SHIP_ORDERS,
      orderType: action.orderType,
      payload: response,
    });
    yield put({ type: SET_SEARCH_PENDING, payload: false });
  } catch (error) {
    console.log(error);
  }
}

export function* getShippedOrder(action) {
  try {
    yield put({ type: SET_SEARCH_PENDING, payload: true });
    const response = yield call(getShippedOrders, action.page ? action.page : 1);
    yield put({
      type: SET_SHIPPED_ORDERS,
      orderType: action.orderType,
      payload: response,
    });
    yield put({ type: SET_SEARCH_PENDING, payload: false });
  } catch (error) {
    console.log(error);
  }
}

export function* getAllOpenpOrder(action) {
  try {
    yield put({ type: SET_SEARCH_PENDING, payload: true });
    const response = yield call(getAllOpenOrders, action.page ? action.page : 1);
    yield put({
      type: SET_OPEN_ORDERS,
      orderType: action.orderType,
      payload: response,
    });
    yield put({ type: SET_SEARCH_PENDING, payload: false });
  } catch (error) {
    console.log(error);
  }
}

export function* getDeliveredOrder(action) {
  try {
    yield put({ type: SET_SEARCH_PENDING, payload: true });
    const response = yield call(getDeliveredOrders, action.page ? action.page : 1);
    yield put({
      type: SET_DELIVERED_ORDERS,
      orderType: action.orderType,
      payload: response,
    });
    yield put({ type: SET_SEARCH_PENDING, payload: false });
  } catch (error) {
    console.log(error);
  }
}

export function* getReturnedOrder(action) {
  try {
    yield put({ type: SET_SEARCH_PENDING, payload: true });
    const response = yield call(getReturnedOrders, action.page ? action.page : 1);
    yield put({
      type: SET_RETURNED_ORDERS,
      orderType: action.orderType,
      payload: response,
    });
    yield put({ type: SET_SEARCH_PENDING, payload: false });
  } catch (error) {
    console.log(error);
  }
}

export function* getCanceledOrder(action) {
  try {
    yield put({ type: SET_SEARCH_PENDING, payload: true });
    const response = yield call(getCanceledOrders, action.page ? action.page : 1);
    yield put({
      type: SET_CANCELED_ORDERS,
      orderType: action.orderType,
      payload: response,
    });
    yield put({ type: SET_SEARCH_PENDING, payload: false });
  } catch (error) {
    console.log(error);
  }
}

export function* getAllCompletedOrder(action) {
  try {
    yield put({ type: SET_SEARCH_PENDING, payload: true });
    const response = yield call(getAllCompletedOrders, action.page ? action.page : 1);
    yield put({
      type: SET_COMPLETED_ORDERS,
      orderType: action.orderType,
      payload: response,
    });
    yield put({ type: SET_SEARCH_PENDING, payload: false });
  } catch (error) {
    console.log(error);
  }
}

export function* confirmAnOrder(action) {
  try {
    yield call(confirmOrder, action.payload.number);
    yield put({ type: CONFIRM_ORDER_SUCCESS, payload: action.payload.number });
    const message = `You have confirmed order #${action.payload.number}. Now generating label...`;
    notifySuccess(message);
    yield put({ type: GET_NEED_TO_CONFIRM_ORDERS });
    yield put({ type: GET_NEED_TO_SHIP_ORDERS });
  } catch (error) {
    yield put({ type: CONFIRM_ORDER_FAIL, payload: action.payload.number });
    const message = `There was an error confirming order #${action.payload.number}.`;
    notifyError(message);
  }
}

export function* cancelAnOrder(action) {
  try {
    const response = yield call(
      cancelOrder,
      action.payload.number,
      action.payload.sellerCanceledReason,
    );

    yield put({ type: CANCEL_ORDER_SUCCESS, payload: response });

    switch (action.payload.openTab) {
      case 'confirm':
        yield put({ type: GET_NEED_TO_CONFIRM_ORDERS });
        break;
      case 'toShip':
        yield put({ type: GET_NEED_TO_SHIP_ORDERS });
        break;
      case 'shipped':
        yield put({ type: GET_SHIPPED_ORDERS });
        break;
      default:
        yield put({ type: GET_OPEN_ORDERS });
    }

    yield put({ type: GET_CANCELED_ORDERS });
  } catch (error) {
    console.log(error);
  }
}

export function* updateAProductPrice(action) {
  try {
    yield call(updateProductPrice, action.payload.product.id, action.payload.product.priceCents);
    yield put({ type: GET_ACTIVE_LISTINGS, page: action.page });
    const message = `The listing price has been successfully updated`;
    notifySuccess(message);
  } catch (error) {
    yield put({
      type: SET_ACTIVE_LISTINGS_ERROR,
      error: error.message,
    });
  }
}

export function* resetStorePrice(action) {
  try {
    yield call(resetToStorePrice, action.payload.product.id);
    yield put({ type: GET_ACTIVE_LISTINGS, page: action.page });
    const message = `The listing price has been successfully reset to your store price. Prices will update at 3AM PST`;
    notifySuccess(message);
  } catch (error) {
    yield put({ type: GET_ACTIVE_LISTINGS });
    const message = `There was an error resetting to your store price`;
    notifyError(message);
  }
}

export function* labelWasPrinted(action) {
  try {
    yield call(labelPrintedIndicator, action.payload);
    yield put({ type: STATUS_UPDATED_SUCCESS });
  } catch (error) {
    yield put({ type: STATUS_UPDATED_FAIL });
  }
}

export function* watchGetActiveListings() {
  yield takeEvery(GET_ACTIVE_LISTINGS, getListings);
}

export function* watchGetProductVariants() {
  yield takeEvery(GET_PRODUCT_VARIANTS, getVariants);
}

export function* watchgetNeedToConfirmOrders() {
  yield takeEvery(GET_NEED_TO_CONFIRM_ORDERS, getNeedToConfirmOrder);
}

export function* watchgetNeedToShipOrders() {
  yield takeEvery(GET_NEED_TO_SHIP_ORDERS, getNeedToShipOrder);
}

export function* watchgetShippedOrders() {
  yield takeEvery(GET_SHIPPED_ORDERS, getShippedOrder);
}

export function* watchgetOpenOrders() {
  yield takeEvery(GET_OPEN_ORDERS, getAllOpenpOrder);
}

export function* watchgetDeliveredOrders() {
  yield takeEvery(GET_DELIVERED_ORDERS, getDeliveredOrder);
}

export function* watchgetReturnedOrders() {
  yield takeEvery(GET_RETURNED_ORDERS, getReturnedOrder);
}

export function* watchgetCanceledOrders() {
  yield takeEvery(GET_CANCELED_ORDERS, getCanceledOrder);
}

export function* watchgetCompletedOrders() {
  yield takeEvery(GET_COMPLETED_ORDERS, getAllCompletedOrder);
}

export function* watchConfirmOrder() {
  yield takeEvery(CONFIRM_ORDER, confirmAnOrder);
}

export function* watchCancelOrder() {
  yield takeEvery(CANCEL_ORDER, cancelAnOrder);
}

export function* watchUpdateAProductPrice() {
  yield takeEvery(UPDATE_PRODUCT_PRICE, updateAProductPrice);
}

export function* watchResetToStorePrice() {
  yield takeEvery(RESET_STORE_PRICE, resetStorePrice);
}

export function* watchLabelPrinted() {
  yield takeEvery(LABEL_PRINTED, labelWasPrinted);
}

export default function* dataSagas() {
  yield all([
    watchGetActiveListings(),
    watchGetProductVariants(),
    watchgetNeedToConfirmOrders(),
    watchConfirmOrder(),
    watchgetNeedToShipOrders(),
    watchgetOpenOrders(),
    watchgetShippedOrders(),
    watchgetDeliveredOrders(),
    watchgetReturnedOrders(),
    watchgetCanceledOrders(),
    watchgetCompletedOrders(),
    watchCancelOrder(),
    watchUpdateAProductPrice(),
    watchResetToStorePrice(),
    watchLabelPrinted(),
  ]);
}
